// タブ
jQuery(function ($) {
  jQuery(function ($) {
    if ($(".js-faq-tab").length > 0) {
      $(".js-tab-item").on("click", function () {
        $(".js-tab-item").removeClass("is-active");
        $(this).addClass("is-active");
        $(".js-tab-content").removeClass("is-active");
        $(".js-tab-content").eq($(this).index()).addClass("is-active");
      });
    }
  });
});

// アコーディオンの起動 // Activate the accordion
jQuery(function ($) {
  if ($(".accordion").length > 0) {
    $(".accordion .toggle").click(function () {
      $(this).next(".contents").slideToggle();
      $(this).toggleClass("open");
    });
  }
});
